var map = {
	"./": [
		51,
		9
	],
	"./App": [
		54,
		9
	],
	"./App.tsx": [
		54,
		9
	],
	"./Routes": [
		58,
		9
	],
	"./Routes.tsx": [
		58,
		9
	],
	"./components/ExampleContainer": [
		60,
		9
	],
	"./components/ExampleContainer.tsx": [
		60,
		9
	],
	"./components/GraphqlProvider": [
		55,
		9
	],
	"./components/GraphqlProvider.tsx": [
		55,
		9
	],
	"./components/Loading": [
		45,
		9
	],
	"./components/Loading.tsx": [
		45,
		9
	],
	"./components/Navigation": [
		39,
		9
	],
	"./components/Navigation.tsx": [
		39,
		9
	],
	"./components/Slide": [
		35,
		9
	],
	"./components/Slide.tsx": [
		35,
		9
	],
	"./components/SlideContainer": [
		59,
		9
	],
	"./components/SlideContainer.tsx": [
		59,
		9
	],
	"./components/SlideNavigation": [
		47,
		9
	],
	"./components/SlideNavigation.tsx": [
		47,
		9
	],
	"./components/SwitchContext": [
		48,
		9
	],
	"./components/SwitchContext.tsx": [
		48,
		9
	],
	"./generated/graphql": [
		141,
		9,
		8
	],
	"./generated/graphql.tsx": [
		141,
		9,
		8
	],
	"./index": [
		51,
		9
	],
	"./index.css": [
		85,
		7
	],
	"./index.tsx": [
		51,
		9
	],
	"./pages/Both/Example1": [
		113,
		9,
		9
	],
	"./pages/Both/Example1.tsx": [
		113,
		9,
		9
	],
	"./pages/Both/Example1Complete": [
		114,
		9,
		10
	],
	"./pages/Both/Example1Complete.tsx": [
		114,
		9,
		10
	],
	"./pages/Both/Example2": [
		115,
		9,
		1
	],
	"./pages/Both/Example2.tsx": [
		115,
		9,
		1
	],
	"./pages/Both/Example2Complete": [
		116,
		9,
		2
	],
	"./pages/Both/Example2Complete.tsx": [
		116,
		9,
		2
	],
	"./pages/Both/Example3": [
		117,
		9,
		3
	],
	"./pages/Both/Example3.tsx": [
		117,
		9,
		3
	],
	"./pages/Both/Example3Complete": [
		118,
		9,
		4
	],
	"./pages/Both/Example3Complete.tsx": [
		118,
		9,
		4
	],
	"./pages/Both/Slide1": [
		119,
		9,
		11
	],
	"./pages/Both/Slide1.tsx": [
		119,
		9,
		11
	],
	"./pages/Both/Slide2": [
		120,
		9,
		12
	],
	"./pages/Both/Slide2.tsx": [
		120,
		9,
		12
	],
	"./pages/Home": [
		61,
		9
	],
	"./pages/Home.tsx": [
		61,
		9
	],
	"./pages/Intro/React-and-typescript.png": [
		170,
		9,
		35
	],
	"./pages/Intro/Slide1": [
		121,
		9,
		6
	],
	"./pages/Intro/Slide1.tsx": [
		121,
		9,
		6
	],
	"./pages/NotFound": [
		62,
		9
	],
	"./pages/NotFound.tsx": [
		62,
		9
	],
	"./pages/Outro/Example1": [
		122,
		9,
		13
	],
	"./pages/Outro/Example1.tsx": [
		122,
		9,
		13
	],
	"./pages/Outro/Questions": [
		123,
		9,
		7
	],
	"./pages/Outro/Questions.tsx": [
		123,
		9,
		7
	],
	"./pages/Outro/React-and-typescript.png": [
		171,
		9,
		36
	],
	"./pages/Outro/Slide1": [
		124,
		9,
		14
	],
	"./pages/Outro/Slide1.tsx": [
		124,
		9,
		14
	],
	"./pages/React/Example1": [
		125,
		9,
		15
	],
	"./pages/React/Example1.tsx": [
		125,
		9,
		15
	],
	"./pages/React/Example1Complete": [
		126,
		9,
		16
	],
	"./pages/React/Example1Complete.tsx": [
		126,
		9,
		16
	],
	"./pages/React/Example2": [
		127,
		9,
		17
	],
	"./pages/React/Example2.tsx": [
		127,
		9,
		17
	],
	"./pages/React/Example2Complete": [
		128,
		9,
		5
	],
	"./pages/React/Example2Complete.tsx": [
		128,
		9,
		5
	],
	"./pages/React/Slide1": [
		129,
		9,
		18
	],
	"./pages/React/Slide1.tsx": [
		129,
		9,
		18
	],
	"./pages/RemoteData/Example1": [
		130,
		9,
		19
	],
	"./pages/RemoteData/Example1.tsx": [
		130,
		9,
		19
	],
	"./pages/RemoteData/Example1Complete": [
		131,
		9,
		20
	],
	"./pages/RemoteData/Example1Complete.tsx": [
		131,
		9,
		20
	],
	"./pages/RemoteData/Slide1": [
		132,
		9,
		21
	],
	"./pages/RemoteData/Slide1.tsx": [
		132,
		9,
		21
	],
	"./pages/TypeScript/Example1": [
		133,
		9,
		22
	],
	"./pages/TypeScript/Example1.tsx": [
		133,
		9,
		22
	],
	"./pages/TypeScript/Example1Complete": [
		134,
		9,
		23
	],
	"./pages/TypeScript/Example1Complete.tsx": [
		134,
		9,
		23
	],
	"./pages/TypeScript/Example2": [
		135,
		9,
		24
	],
	"./pages/TypeScript/Example2.tsx": [
		135,
		9,
		24
	],
	"./pages/TypeScript/Example2Complete": [
		136,
		9,
		25
	],
	"./pages/TypeScript/Example2Complete.tsx": [
		136,
		9,
		25
	],
	"./pages/TypeScript/Slide1": [
		137,
		9,
		26
	],
	"./pages/TypeScript/Slide1.tsx": [
		137,
		9,
		26
	],
	"./pages/TypeScript/Slide2": [
		138,
		9,
		27
	],
	"./pages/TypeScript/Slide2.tsx": [
		138,
		9,
		27
	],
	"./placeholder.graphql": [
		172,
		9,
		33
	],
	"./react-app-env.d": [
		139,
		7,
		28
	],
	"./react-app-env.d.ts": [
		139,
		7,
		28
	],
	"./reportWebVitals": [
		64,
		9
	],
	"./reportWebVitals.ts": [
		64,
		9
	],
	"./setupTests": [
		140,
		9,
		0,
		29
	],
	"./setupTests.ts": [
		140,
		9,
		0,
		29
	],
	"./theme": [
		63,
		9
	],
	"./theme.ts": [
		63,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 163;
module.exports = webpackAsyncContext;